import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { AddressesController } from './addresses.controller';
import { AddressesRepository, PrismaAddressesRepository } from './addresses.repository';
import { AddressesService } from './addresses.service';

@Module({
  imports: [AuthModule],
  controllers: [AddressesController],
  providers: [
    AddressesService,
    PrismaService,
    {
      provide: AddressesRepository,
      useClass: PrismaAddressesRepository,
    },
  ],
})
export class AddressesModule {}
